import {useInjex} from '@injex/react-plugin';
import UserManager from '../managers/UserManager.mdl';

export default function useUserManager(): UserManager {
    const [inject] = useInjex();
    return inject<UserManager>('userManager');
}
